import React from 'react';
import { FormFieldContainer } from './FormFieldContainer';
import { ConditionalFields } from '../formFields';
import { SectionLabel } from '@kula-ai/components';
import { Separator } from '@/components/ats/Separator';

const defaultFieldConfig = {
  type: null,
  label: '',
  fields: [],
  sectionConfig: {},
  wrapperProps: {},
  wrapper: null,
  Field: null,
  Wrapper: null,
  props: {},
  function: null,
  isConditional: false,
  custom: false,
  customField: null,
  customFieldProps: {},
  customFieldWrapper: null,
  separatorConfig: { textStyles: {}, containerStyles: {}, title: '' },
};

export const FormItem = ({
  field = defaultFieldConfig,
  formik = {},
  useGridStyles = false,
}) => {
  // Handle null or undefined fields
  if (!field || field === null) {
    return null;
  }

  // Handle Separator
  if (field?.type === 'separator') {
    return <Separator separatorConfig={field?.separatorConfig} />;
  }

  if (field?.type === 'sectionLabel') {
    return (
      <SectionLabel {...field?.sectionConfig}>
        {' '}
        {field?.label || ''}{' '}
      </SectionLabel>
    );
  }

  // Handle custom fields:
  if (field?.type === 'function' && field?.function) {
    return <field.Field formik={formik} {...field?.props} />;
  }

  // Handle custom fields:
  if (field?.type === 'invisible') {
    return <></>;
  }

  // Handle conditional rendering:
  if (field?.isConditional) {
    return (
      <ConditionalFields
        field={field}
        formik={formik}
        useGridStyles={useGridStyles}
      />
    );
  }

  // Handle custom fields:
  if (field?.type === 'custom' && field.Field) {
    return <field.Field formik={formik} {...field?.props} />;
  }

  // Handle wrappers and non-wrappers consistently:
  const content = (
    <>
      {field.fields?.map((subField, subIndex) => {
        // Handle conditional rendering for wrapper fields
        if (subField?.isConditional) {
          return (
            <ConditionalFields
              key={subIndex}
              field={subField}
              formik={formik}
              useGridStyles={useGridStyles}
            />
          );
        }
        return (
          <React.Fragment key={subIndex}>
            <FormItem field={subField} formik={formik} />
          </React.Fragment>
        );
      })}
      {!field.fields && (
        <FormFieldContainer
          item={field}
          formik={formik}
          useGridStyles={useGridStyles}
        />
      )}
    </>
  );

  // Use a wrapper component if available:
  return field.Wrapper ? (
    <field.Wrapper {...field.wrapperProps}>{content}</field.Wrapper>
  ) : (
    content
  );
};
